// eslint-disable-next-line no-unused-vars
const config = {
  defaultLanguage: 'en',
  supportedLanguages: [
    'en',
    'de',
    'ru'
  ],
  headerImages: {
    type: 'image/jpeg',
    quality: 0.9
  }
}
